// removed by extract-text-webpack-plugin
module.exports = {"preview":"_2jujOPIUSCQYFQdiXbkGyw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/elements/Tooltips/TooltipShowcase.css
// module id = 1187
// module chunks = 0